var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0060C6",
    fillRule: "evenodd",
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.688 12c.562 0 1.038.222 1.426.665.388.443.582.975.582 1.595s-.197 1.148-.59 1.585c-.394.437-.867.655-1.418.655-.54 0-1.005-.218-1.393-.655-.388-.437-.582-.965-.582-1.586 0-.62.191-1.151.574-1.595.382-.442.85-.664 1.4-.664zm.034 7.043h.81l-2.785 10.861c-.146.62-.22 1.032-.22 1.234 0 .102.04.203.119.304.078.102.163.152.253.152.157 0 .31-.076.455-.228.417-.38.906-1.064 1.469-2.05l.472.303c-1.372 2.684-2.83 4.026-4.371 4.026-.585 0-1.052-.187-1.4-.56-.35-.374-.524-.846-.524-1.415 0-.38.078-.861.236-1.443l1.89-7.31c.18-.697.27-1.222.27-1.577 0-.227-.087-.43-.26-.607-.175-.177-.409-.266-.701-.266-.147 0-.31.007-.49.019l.169-.608 4.608-.835z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconInfo);
export default __webpack_public_path__ + "static/media/alert-icon-info.a6b8eebad874605bdc78b8d863e4cf8c.svg";
export { ForwardRef as ReactComponent };